// extracted by mini-css-extract-plugin
export default {"loaderContent":"Loading_loaderContent__kyjTX","loader":"Loading_loader__XJMh0","spin":"Loading_spin__qUF5r"};